import {NariaIcon, NumberIcon} from "../../../assets/icons";
import React from "react";
import {CustomerInvoicesInfo} from "./CustomerInvoicesInfo";
import {CustomerT} from "../../../types";
import { formatMoney } from "../../../utils";

interface CustomerInvoicesProps {
  customer: CustomerT;
}
export const CustomerInvoices: React.FC<CustomerInvoicesProps> = ({ customer }) => (
  <div className="flex gap-[10px]  md:justify-start md:items-start w-full md:ml-[1.7em] lg:ml-[-4em] lg:gap-[1em] xl:gap-[2em] md:gap-[2em] 360:ml-[-1.6em] 375:ml-[-1.3em] 414:ml-[1.4em] 412:ml-[2em] 540:ml-[5em]">
    <div className="">
      <CustomerInvoicesInfo
        title="Total Billed"
        value={customer?.totalBilled ? formatMoney(customer?.totalBilled) : '0'}
        color="active"
        icon={<NumberIcon />}
      />
    </div>
    <div className="ml-[0.2em] md:ml-0 " >
      <CustomerInvoicesInfo
        title="Number of Invoices"
        value={customer?.totalInvoices ? `${customer?.totalInvoices}` : 0}
        color="secondary"
        icon={<NariaIcon />}
      />
    </div>
  </div>
);
